interface SpinnerProps {
  label?: string;
}

/** Индикатор загрузки на месте гейта (RootGate/AuthGate). */
export function Spinner({ label = 'Загрузка…' }: SpinnerProps) {
  return (
    <div className="spinner">
      <span className="spinner__ring" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
